import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid, FormControl, InputLabel, Select, MenuItem, } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createTurnDefinitionAction, updateTurnDefinitionAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const { data, handleClose, schedules } = props;
  const dispatch = useDispatch();

  const create = (dataToSend) => {
    dispatch(createTurnDefinitionAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (dataToSend) => {
    dispatch(updateTurnDefinitionAction(dataToSend))
      .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    isCreate,
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, create, modify, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} sm={4} style={gridStyle}> {/* codigo */}
          <TextField
            disabled={!Boolean(isCreate)}
            required
            fullWidth
            margin={"none"}
            label={getLocalizedString("shiftCode")}
            onChange={(e) => setFormValue(e.target.value, "code")}
            value={formData.code}
            inputProps={{ maxLength: 12 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={4} style={gridStyle}> {/* nombre */}
          <TextField
            required
            fullWidth
            margin={"none"}
            label={getLocalizedString("shiftName")}
            value={formData.name}
            onChange={(e) => setFormValue(e.target.value, "name")}
            inputProps={{ maxLength: 40 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} sm={4} style={gridStyle}> {/* Código de horario */}
          <FormControl style={{ width: "100%" }}>
            <InputLabel id={`label-holidaySchedule`}>{getLocalizedString("holidaySchedule")}</InputLabel>
            <Select
              value={formData.holidaySchedule}
              labelId={`label-holidaySchedule`}
              id={`select-holidaySchedule`}
              onChange={(e) => setFormValue(e.target.value, "holidaySchedule")}
              margin={"none"}
            >
              {
                schedules && schedules.map(item => (
                  <MenuItem
                    className={"whiteText"}
                    key={item.key}
                    value={item.key}>
                    {item.value}
                  </MenuItem>
                ))
              }
            </Select>
          </FormControl>
        </Grid>
        <Grid container item alignItems="center" xs={12} style={{ padding: "10px 10px" }}> {/* detalle */}
          <TextFieldMultiline
            fullWidth
            label={getLocalizedString("shiftDetail")}
            rows={5}
            margin={"none"}
            value={formData.detail}
            onChange={(e) => setFormValue(e.target.value, "detail")}
            inputProps={{ spellCheck: 'false' }}
          />
        </Grid>
      </Grid>
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>
    </Grid >
  );
}

export default Form;
